import { GetterTree } from 'vuex'

import { RootState } from '../../types'
import { SearchContactLensState } from './types'

export const getters: GetterTree<SearchContactLensState, RootState> = {

}
